<template>
  <DataTable
    :loading="!header"
    :value="filteredDataArray"
    showGridlines
    rowGroupMode="rowspan"
    groupRowsBy="numberSection"
    responsiveLayout="scroll"
    class="p-datatable-sm editable-cells-table"
    :rowClass="rowClass"
    id="dataPermitChecklist"
  >
    <Column
      field="numberSection"
      :header="$t('numberSection')"
      key="section"
      class="w-4"
    >
      <!-- <template #body="slotProps">
                <InputText name="section" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('section')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template> -->
    </Column>
    <Column field="description" :header="$t('ChecklistCode')" key="description">
      <!-- <template #body="slotProps">
                <InputText name="description" v-model="slotProps.data[slotProps.column.props.field]" type="text"
                    :placeholder="$t('risk_des')" :disabled="true" @change="onCellEditComplete(slotProps)" />
            </template> -->
    </Column>
    <Column field="ValueYes" :header="$t('yes')" key="ValueYes">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="
            mode == this.$FORM_MODE_VERIFY ||
            slotProps.data.ValueNo == 'Y' ||
            slotProps.data.ValueNA == 'Y' ||
            this.status == 'REL' ||
            this.status == 'OPN' ||
            this.status == 'CLS' ||
            this.status == 'COM' ||
            (this.status == 'REJ' && this.permitReview == 'Y') ||
            (this.status == 'PRG' && this.permitReview == 'Y')
          "
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="ValueNo" :header="$t('no')" key="ValueNo">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="
            mode == this.$FORM_MODE_VERIFY ||
            slotProps.data.ValueYes == 'Y' ||
            slotProps.data.ValueNA == 'Y' ||
            this.status == 'REL' ||
            this.status == 'OPN' ||
            this.status == 'CLS' ||
            this.status == 'COM' ||
            (this.status == 'REJ' && this.permitReview == 'Y') ||
            (this.status == 'PRG' && this.permitReview == 'Y')
          "
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
    <Column field="ValueNA" :header="$t('na')" key="ValueNA">
      <template #body="slotProps">
        <YNCheckbox
          v-model="slotProps.data[slotProps.column.props.field]"
          :binary="true"
          :disabled="
            mode == this.$FORM_MODE_VERIFY ||
            slotProps.data.ValueYes == 'Y' ||
            slotProps.data.ValueNo == 'Y' ||
            this.status == 'REL' ||
            this.status == 'OPN' ||
            this.status == 'CLS' ||
            this.status == 'COM' ||
            (this.status == 'REJ' && this.permitReview == 'Y') ||
            (this.status == 'PRG' && this.permitReview == 'Y')
          "
          @change="onCellEditComplete(slotProps)"
        />
      </template>
    </Column>
  </DataTable>
</template>
<script>
export default {
  props: {
    dataArray: {
      type: Array,
      default: [],
    },
    dataModel: {
      type: Object,
      default: [],
    },
    mode: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
    preuser: {
      type: String,
      default: "",
    },
    duruser: {
      type: String,
      default: "",
    },
    permitReview: {
      type: String,
      default: "",
    },
    postuser: {
      type: String,
      default: "",
    },
    header: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      companyCode: this.$store.getters.getCompanyCode,
    };
  },
  methods: {
    rowClass(data) {
      if (data.section === "pre") {
        return "classBlue";
      } else if (data.section === "dur") {
        return "classYellow";
      } else if (data.section === "post") {
        return "classGreen";
      }
    },
    addDetail() {
      var newDetail = this.dataModel;
      newDetail.mode = this.$FORM_MODE_CREATE;
      var det = { ...newDetail };

      this.dataArray.push(det);
    },
    deleteDetail(event) {
      if (event) {
        var detail = this.dataArray[event.index];

        if (detail.mode == this.$FORM_MODE_CREATE)
          this.dataArray.splice(this.dataArray.indexOf(detail), 1);
        else detail.mode = this.$FORM_MODE_DELETE;
      }
    },
    onCellEditComplete(event) {
      this.editDetail(event.index);
    },
    editDetail(index) {
      if (this.dataArray && this.dataArray.length > 0) {
        let m = this.dataArray[index].mode;

        if (m == this.$FORM_MODE_UNCHANGED) {
          this.dataArray[index].mode = this.$FORM_MODE_EDIT;
        }
      }
    },
    changever(event, e) {
      if (this.dataArray && this.dataArray.length > 0) {
        this.dataArray[event.index].Version = e == null ? "1" : e.id;
      }
    },
  },
  computed: {
    canEdit() {
      return (
        this.mode == this.$FORM_MODE_CREATE || this.mode == this.$FORM_MODE_EDIT
      );
    },
    filteredDataArray() {
      // Filter the data to include only those with "pre" in the section
      return this.dataArray.filter((item) => item.section === "post");
    },
  },
};
</script>

<style type="text/css">
#dataPermitChecklist .classBlue {
  background-color: #ebd234 !important;
}

#dataPermitChecklist .classYellow {
  background-color: #65c5d8 !important;
}

#dataPermitChecklist .classGreen {
  background-color: #40eb34 !important;
}
</style>
